import { Typography } from "@mui/material";
import Link from "next/link";
import React from "react";

const CopyRightComponent = ({ ...props }) => {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {"Copyright © "}
      <Link color="inherit" href="https://www.herofincorp.com/">
        Hero Fincorp Limited
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
};

export default CopyRightComponent;
